import SERVICE_URL from "../config/API_DATA";
import HttpPost from "../http/httppost.js";
import Logger from "./logger.js";
import { FILE_NAME, LOG_TYPE } from "../config/API_DATA";

export default class AssignTiers {
    static buildRequest(pricingList) {
        let returnValue = null;
        try {
            for (
                let index = 0;
                index < pricingList.length;
                index++
            ) {
                const pList = pricingList[index];
                let body = {
                    b2bId: pList.b2bId,
                    tiers: []
                };
                for (
                    let list = 0;
                    list < pList.tiers.length;
                    list++
                ) {
                    const tList = pList.tiers[list];
                    if (tList.isEnable == true) {
                        let tierObj = {
                            tierId: tList.tierid,
                            fromDate: tList.fromDate,
                            toDate: tList.toDate
                        }
                        body.tiers.push(tierObj);
                    }
                }
                returnValue = body;
            }





        } catch (err) {
            let body = Logger.buildRequest(
                FILE_NAME.API_ASSIGN_TIERS,
                "error in building body for AssignTiers",
                err.toString(),
                "buildRequest",
                LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
        }
        return returnValue;
    }

    static async getResponse(pReqOptions) {
        let returnValue = null;
        try {
            returnValue = await HttpPost.makeHttpPostRequest(
                SERVICE_URL.ASSIGN_TIERS,
                pReqOptions
            );
        } catch (err) {
            let body = Logger.buildRequest(
                FILE_NAME.API_ASSIGN_TIERS,
                "error in getting Response from  AssignTiers ",
                err.toString(),
                "getResponse",
                LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
        }
        return returnValue;
    }
}
